import Promise from 'bluebird';

const ExportedPromise = process.env.__DEV__ ? window.Promise : Promise;

export default ExportedPromise;
